import { useQuery } from '@tanstack/vue-query';
import { queries } from '~/keys';

export type FreeTierRemaining = {
  chat: { used: number; limit: number; remaining: number };
  marketing: { used: number; limit: number; remaining: number };
};

export const useFreeTierRemainingQuery = (enabled: MaybeRefOrGetter<boolean>) => {
  const authStore = useAuthStore();

  return useQuery({
    ...queries.freeTier.remaining,
    queryFn: () =>
      $fetch<{ data: FreeTierRemaining }>('/api/free-tier/remaining', {
        headers: { Authorization: `Bearer ${authStore.token}` },
      }).then((r) => r.data),
    enabled: computed(() => toValue(enabled)),
    retry: false,
  });
};

export type FreeTierOnboarding = {
  lesson: boolean;
  chat: boolean;
  marketing: boolean;
  deal: boolean;
};

export const useFreeTierOnboardingQuery = (enabled: MaybeRefOrGetter<boolean>) => {
  const authStore = useAuthStore();

  return useQuery({
    ...queries.freeTier.onboarding,
    queryFn: () =>
      $fetch<{ data: FreeTierOnboarding }>('/api/free-tier/onboarding', {
        headers: { Authorization: `Bearer ${authStore.token}` },
      }).then((r) => r.data),
    enabled: computed(() => toValue(enabled)),
    retry: false,
  });
};
